import { defineMessages } from 'react-intl';

export default defineMessages({
    wantToDelete: {
            "id": "translation.ConstructionDetails.wantToDelete",
            "defaultMessage": "Remove Roofing Update"
    },
    roofingCancelMessage: {
        "id": "translation.ConstructionDetails.cancelMessage",
        "defaultMessage": "Are you sure you want to remove this roofing update?"
    },
    yesModal: {
        "id": "translation.ConstructionDetails.Yes",
        "defaultMessage": "Yes"
    },
    closeModal: {
        "id": "translation.ConstructionDetails.Close",
        "defaultMessage": "Close"
    },
    noModal: {
        "id": "translation.ConstructionDetails.No",
        "defaultMessage": "No"
    },
    roofingAlert: {
        "id": "translation.ConstructionDetails.Roofing Alert",
        "defaultMessage": "Unable to Deselect Roofing Updates"
    },
    alertMessage: {
        "id": "translation.ConstructionDetails.Alert Message",
        "defaultMessage": "You must remove all the Roofing Updates records in order to uncheck this box."
    },
    // DE15522
    roofingUpdatesMH: {
        "id": "quoteandbind.views.Roofing Updates Manufactured Home",
        "defaultMessage": "Added Living Space Roofing Updates"
    },
    roofingUpdates: {
        "id": "quoteandbind.views.Roofing Updates",
        "defaultMessage": "Roofing Updates"
    },
    modelYearMessage: {
        "id": "twia.quoteandbind.views.Model Year Message",
        "defaultMessage": "Model year must be in YYYY format."
    },
    cannotBeFutureDate: {
        "id": "quoteandbind.ho.views.construction.Date in the future.",
        "defaultMessage" : "Date cannot be in the future."
    },
    requiredField: {
        id: 'quoteandbind.contacts.policyroles.required field Validation',
        defaultMessage: 'This is a required field.',
    },
})